import axios from "axios";
import useAxiosAuthentication from "@/compositions/useAxiosAuthentication";
import { DEFAULT_HEADERS } from "@/compositions/useAxios/data.ts";

const axiosInstance = axios.create({
  headers: {
    ...DEFAULT_HEADERS,
    "api-key": import.meta.env.VITE_TENANT_API_KEY
  }
});
useAxiosAuthentication(axiosInstance);

export default axiosInstance;
